import { createContext } from "react";

const RejectedParentTransaction = createContext<any>(null);

export default RejectedParentTransaction;
